import React, { Component } from 'react';
import classNames from 'classnames';

export default class Logo extends Component {
    render() {
        const {
            loading, animated,
            small, medium, large, xlarge, xxlarge,
            reverse, center, centerFlex,
            className, style, color
        } = this.props;

        const sizeClasses = {
            'w-6 h-6': small,
            'w-12 h-12': medium || (!small && !large && !xlarge && !xxlarge),
            'w-24 h-24': large,
            'w-48 h-48': xlarge,
            'w-96 h-96': xxlarge,
        };

        const classes = classNames(
            'lysep-logo inline-block',
            sizeClasses,
            {
                'animate-spin': loading, // Using standard spin for loading
                'animate-spin-menu': animated, // Custom animation
                'text-primary': !reverse,
                'text-white': reverse,
                'mx-auto block': center,
                'flex w-full justify-center items-center': centerFlex,
            },
            className
        );

        return (
            <div className={classes} style={style}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 951 951"
                    className="w-full h-full fill-current"
                >
                    <title>lysep logo</title>
                    <path
                        style={color ? { fill: color } : {}}
                        d="M499.91,24.4C237.3,24.4,24.4,237.3,24.4,499.91c0,.69,0,1.4,0,2.09H191.25c0-171.62,139.13-310.75,310.75-310.75V24.42C501.31,24.4,500.6,24.4,499.91,24.4ZM224.81,642.59,77.48,718.42A477.58,477.58,0,0,0,268.69,915.51l80.27-143A312.08,312.08,0,0,1,224.81,642.59ZM812.75,502c0,171.62-139.13,310.75-310.75,310.75V975.4C763,974.3,974.3,763,975.4,502ZM735.21,86.62,654.14,231A312.21,312.21,0,0,1,778.36,359.76l145.72-75A477.76,477.76,0,0,0,735.21,86.62Z"
                        transform="translate(-24.4 -24.4)"
                    />
                    <path
                        style={color ? { fill: color } : {}}
                        d="M627.87,434a144.24,144.24,0,0,0-57.52-59.62A143.93,143.93,0,0,0,371.1,564.12,143.92,143.92,0,1,0,627.87,434Z"
                        transform="translate(-24.4 -24.4)"
                    />
                </svg>
            </div>
        )
    }
}

